export const SET_THEME_MODE = 'SET_THEME_MODE'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_CUSTOMER_VISIBLE = 'SET_CUSTOMER_VISIBLE'
export const SET_CACHE_INFO = 'SET_CACHE_INFO'
export const SET_SYSTEM_CONFIG = 'SET_SYSTEM_CONFIG'
export const SET_DICT = 'SET_DICT'
export const SET_HIDE_BALANCE = 'SET_HIDE_BALANCE'
export const SET_LOCALE_POP_VISIBLE = 'SET_LOCALE_POP_VISIBLE'
export const SET_FAVORITE_CURRENCIES = 'SET_FAVORITE_CURRENCIES'
export const SET_VC_ID = 'SET_VC_ID'
export const SET_TRADE_CONFIG = 'SET_TRADE_CONFIG'
export const SET_VC_LIST = 'SET_VC_LIST'
export const SET_CONTRACT_TRADE_CONFIG = 'SET_CONTRACT_TRADE_CONFIG'
export const SET_CONTRACT_TRADE_DETAIL_MESSAGE = 'SET_CONTRACT_TRADE_DETAIL_MESSAGE'
export const SET_CURRENT_LOCALE = 'SET_CURRENT_LOCALE'
export const SET_LOCALE_LIST = 'SET_LOCALE_LIST'
export const SET_COIN_LIST_WITH_PRICE = 'SET_COIN_LIST_WITH_PRICE'



// WEBPACK FOOTER //
// ./src/store/nameSpace.js